import { setupInterceptors } from "./axios";

function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

export const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

export const tokenExpired = (exp: number) => {
  let expiredTimer;

  const currentTime = Date.now();

  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    alert('Token expired');

    localStorage.removeItem('accessToken');

    window.location.href = '/auth/login';
  }, timeLeft);
};


export const setSession = ({accessToken,refreshToken}:Partial<{accessToken?: string, refreshToken?: string}>) => {
  return new Promise((resolve) => {
    if (accessToken && refreshToken) {
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);

      resolve({ accessToken });
    } else {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      resolve('');
    }
  });
};

export const getSession = () => localStorage.getItem('accessToken');

export const getRefresh = () => localStorage.getItem('refreshToken')

